"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var colorHelpers_1 = __importDefault(require("../../utils/colorHelpers"));
var Container = styled_components_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: ", " ;\n  display: ", ";\n  justify-content: ", ";\n  padding: 0;\n\n  .c-axs-tab {\n    color: ", ";\n    cursor: pointer;\n    border-bottom: ", ";\n    border-left: ", ";\n    display: ", ";\n    padding: ", ";\n    font-size: ", ";\n    font-weight: 300;\n    line-height: ", ";\n    text-align: ", ";\n    text-transform: ", ";\n    width: ", ";\n\n    a {\n        text-decoration: none;\n        color: ", ";\n    }\n  }\n\n  .c-axs-tab--active {\n    color: ", ";\n    text-shadow: ", ";\n    border-bottom: ", ";\n    border-left: ", ";\n    a {\n        color: ", ";\n    }\n  }\n"], ["\n  border-bottom: ", " ;\n  display: ", ";\n  justify-content: ", ";\n  padding: 0;\n\n  .c-axs-tab {\n    color: ", ";\n    cursor: pointer;\n    border-bottom: ",
    ";\n    border-left: ",
    ";\n    display: ", ";\n    padding: ", ";\n    font-size: ", ";\n    font-weight: 300;\n    line-height: ", ";\n    text-align: ", ";\n    text-transform: ",
    ";\n    width: ", ";\n\n    a {\n        text-decoration: none;\n        color: ",
    ";\n    }\n  }\n\n  .c-axs-tab--active {\n    color: ", ";\n    text-shadow: ",
    ";\n    border-bottom: ",
    ";\n    border-left: ",
    ";\n    a {\n        color: ", ";\n    }\n  }\n"])), function (_a) {
    var horizontal = _a.horizontal;
    return horizontal ? "1px solid " + colors_1.colors.GREY_300 : 'none';
}, function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? 'flex' : 'block ');
}, function (_a) {
    var fluid = _a.fluid;
    return (fluid ? 'space-between' : 'flex-start');
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return colorHelpers_1.default(color, theme, colors_1.colors.GREY_500);
}, function (_a) {
    var horizontal = _a.horizontal;
    return horizontal ? "5px solid " + colors_1.colors.TRANSPARENT : 'none';
}, function (_a) {
    var horizontal = _a.horizontal;
    return !horizontal ? "5px solid " + colors_1.colors.TRANSPARENT : 'none';
}, function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? 'inline-block' : 'block');
}, function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? '0 16px 6px' : '0 0 0 16px');
}, function (_a) {
    var horizontal = _a.horizontal;
    return horizontal ? '14px' : '13px';
}, function (_a) {
    var horizontal = _a.horizontal;
    return (!horizontal ? '40px' : 'auto');
}, function (_a) {
    var menuAlign = _a.menuAlign;
    return menuAlign;
}, function (_a) {
    var horizontal = _a.horizontal;
    return !horizontal ? 'uppercase' : 'inherit';
}, function (_a) {
    var fluid = _a.fluid;
    return (fluid ? '100%' : 'auto');
}, function (_a) {
    var color = _a.color, horizontal = _a.horizontal, theme = _a.theme;
    return horizontal
        ? utils_1.parseThemePath(color, theme, colors_1.colors.GREY_450)
        : utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_300);
}, function (_a) {
    var colorActive = _a.colorActive, theme = _a.theme;
    return utils_1.parseThemePath(colorActive, theme, colors_1.colors.BLUE_MEDIUM_300);
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return " -.2px -.2px 0 " + utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_300) + ",\n    .2px -.2px 0 " + utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_300) + ",\n    -.2px .2px 0 " + utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_300) + ",\n    .2px .2px 0 " + utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_300) + " ";
}, function (_a) {
    var horizontal = _a.horizontal, borderColor = _a.borderColor, theme = _a.theme;
    return horizontal
        ? "5px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_MEDIUM_300)
        : 'none';
}, function (_a) {
    var horizontal = _a.horizontal, borderColor = _a.borderColor, theme = _a.theme;
    return !horizontal
        ? "5px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_MEDIUM_300)
        : colors_1.colors.GREY_450;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_MEDIUM_300);
});
var AXSMenu = function (props) {
    var newChildren = React.Children.map(props.children, function (child) {
        return React.cloneElement(child, {
            handleMenuClick: props.handleMenuClick ? props.handleMenuClick : function () {
            },
        });
    });
    return (React.createElement(Container, __assign({ role: "menubar" }, props, { className: classnames_1.default(['c-axs-menu', props.className]) }), newChildren));
};
AXSMenu.defaultProps = {
    backgroundColor: 'axsui.components.menu.backgroundColor',
    backgroundColorActive: 'axsui.components.menu.backgroundColorActive',
    borderColor: 'axsui.components.menu.borderColor',
    borderColorActive: 'axsui.components.menu.borderColorActive',
    color: 'axsui.components.menu.color',
    colorActive: 'axsui.components.menu.colorActive',
    fluid: false,
    horizontal: false,
    menuAlign: 'left',
};
exports.default = AXSMenu;
var templateObject_1;
//# sourceMappingURL=index.js.map